export const paymentDates = ['ASAP', '25th day of the month'];
